var _global = typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

_global.SENTRY_RELEASE = {
  id: "b55ffd8fe9d5bc9cb57ff743316aaf99237dae1a"
};